import type { WhosCallingParams } from "@/api/whosCalling";
import { listingKeys } from "./buyerKeys";

/**
 * Addendum B (B2) — "Who's calling?" query keys. Under the LISTING prefix: the
 * results are listings, agents and their submissions, so any listing or agent
 * save (which invalidates `listingKeys.all`) refreshes an open panel.
 */
export const whosCallingKeys = {
  all: [...listingKeys.all, "whos-calling"] as const,
  search: (params: WhosCallingParams) => [...whosCallingKeys.all, params] as const,
};
